import { render } from "./GDPRContent.vue?vue&type=template&id=2ee2828e"
import script from "./GDPRContent.vue?vue&type=script&lang=js"
export * from "./GDPRContent.vue?vue&type=script&lang=js"

import "./GDPRContent.vue?vue&type=style&index=0&id=2ee2828e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__